import React from 'react';
import { Link } from 'react-router-dom';
import { TruckIcon, PackageIcon, ClipboardCheckIcon, MapPinIcon } from 'lucide-react';
import { Button } from '../components/Button';
export const HomePage = () => {
  return <div className="w-full" data-id="element-144">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white" data-id="element-145">
        <div className="container mx-auto px-4 py-20 md:py-32" data-id="element-146">
          <div className="flex flex-col md:flex-row items-center" data-id="element-147">
            <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-148">
              <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-149">
                Moving Made Simple Across Estonia
              </h1>
              <p className="text-xl mb-8 text-blue-100" data-id="element-150">
                Professional, reliable, and stress-free moving services for
                homes and businesses.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-151">
                <Link to="/order" data-id="element-152">
                  <Button variant="secondary" size="lg" data-id="element-153">
                    Book Your Move
                  </Button>
                </Link>
                <Button variant="outline" size="lg" className="bg-transparent border-white text-white hover:bg-white hover:bg-opacity-10" data-id="element-154">
                  Learn More
                </Button>
              </div>
            </div>
            <div className="md:w-1/2 md:pl-10" data-id="element-155">
              <img src="https://images.unsplash.com/photo-1600518464441-9306b0ad5ec7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Professional movers packing boxes" className="rounded-lg shadow-xl" data-id="element-156" />
            </div>
          </div>
        </div>
      </section>
      {/* How It Works */}
      <section className="py-16 bg-white" data-id="element-157">
        <div className="container mx-auto px-4" data-id="element-158">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-159">How It Works</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-160">
            <div className="flex flex-col items-center text-center" data-id="element-161">
              <div className="bg-blue-100 p-4 rounded-full mb-6" data-id="element-162">
                <ClipboardCheckIcon size={32} className="text-blue-600" data-id="element-163" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-164">1. Book Your Move</h3>
              <p className="text-gray-600" data-id="element-165">
                Fill out our simple form with your moving details and
                requirements.
              </p>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-166">
              <div className="bg-blue-100 p-4 rounded-full mb-6" data-id="element-167">
                <PackageIcon size={32} className="text-blue-600" data-id="element-168" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-169">2. Get Packed</h3>
              <p className="text-gray-600" data-id="element-170">
                Our professional team arrives with all necessary equipment to
                pack and load your belongings.
              </p>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-171">
              <div className="bg-blue-100 p-4 rounded-full mb-6" data-id="element-172">
                <TruckIcon size={32} className="text-blue-600" data-id="element-173" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-174">3. We Deliver</h3>
              <p className="text-gray-600" data-id="element-175">
                We transport your items safely to your new location and help you
                unpack.
              </p>
            </div>
          </div>
          <div className="text-center mt-12" data-id="element-176">
            <Link to="/order" data-id="element-177">
              <Button size="lg" data-id="element-178">Book Now</Button>
            </Link>
          </div>
        </div>
      </section>
      {/* Services */}
      <section className="py-16 bg-gray-50" data-id="element-179">
        <div className="container mx-auto px-4" data-id="element-180">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-181">Our Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-182">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-183">
              <h3 className="text-xl font-bold mb-3" data-id="element-184">Home Moving</h3>
              <p className="text-gray-600 mb-4" data-id="element-185">
                Complete moving services for apartments and houses of any size.
              </p>
              <Link to="/order" className="text-blue-600 font-medium hover:underline" data-id="element-186">
                Learn more →
              </Link>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-187">
              <h3 className="text-xl font-bold mb-3" data-id="element-188">Office Relocation</h3>
              <p className="text-gray-600 mb-4" data-id="element-189">
                Efficient business moving with minimal disruption to your
                operations.
              </p>
              <Link to="/order" className="text-blue-600 font-medium hover:underline" data-id="element-190">
                Learn more →
              </Link>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-191">
              <h3 className="text-xl font-bold mb-3" data-id="element-192">Packing Services</h3>
              <p className="text-gray-600 mb-4" data-id="element-193">
                Professional packing of your belongings with quality materials.
              </p>
              <Link to="/order" className="text-blue-600 font-medium hover:underline" data-id="element-194">
                Learn more →
              </Link>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-195">
              <h3 className="text-xl font-bold mb-3" data-id="element-196">Storage Solutions</h3>
              <p className="text-gray-600 mb-4" data-id="element-197">
                Secure storage options for short and long-term needs.
              </p>
              <Link to="/order" className="text-blue-600 font-medium hover:underline" data-id="element-198">
                Learn more →
              </Link>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-199">
              <h3 className="text-xl font-bold mb-3" data-id="element-200">Furniture Assembly</h3>
              <p className="text-gray-600 mb-4" data-id="element-201">
                Expert assembly and disassembly of furniture items.
              </p>
              <Link to="/order" className="text-blue-600 font-medium hover:underline" data-id="element-202">
                Learn more →
              </Link>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-203">
              <h3 className="text-xl font-bold mb-3" data-id="element-204">Special Items</h3>
              <p className="text-gray-600 mb-4" data-id="element-205">
                Careful handling of pianos, artwork, antiques, and other
                valuables.
              </p>
              <Link to="/order" className="text-blue-600 font-medium hover:underline" data-id="element-206">
                Learn more →
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials */}
      <section className="py-16 bg-white" data-id="element-207">
        <div className="container mx-auto px-4" data-id="element-208">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-209">
            What Our Customers Say
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-210">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-211">
              <div className="flex items-center mb-4" data-id="element-212">
                <div className="flex text-yellow-400" data-id="element-213">
                  {[...Array(5)].map((_, i) => <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-214">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-215" />
                    </svg>)}
                </div>
              </div>
              <p className="text-gray-600 mb-4" data-id="element-216">
                "The team was professional, efficient, and took great care with
                our belongings. Made our move stress-free!"
              </p>
              <p className="font-medium" data-id="element-217">- Mari Tamm, Tallinn</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-218">
              <div className="flex items-center mb-4" data-id="element-219">
                <div className="flex text-yellow-400" data-id="element-220">
                  {[...Array(5)].map((_, i) => <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-221">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-222" />
                    </svg>)}
                </div>
              </div>
              <p className="text-gray-600 mb-4" data-id="element-223">
                "Excellent service from start to finish. The online booking
                system was easy to use and the movers were punctual and
                careful."
              </p>
              <p className="font-medium" data-id="element-224">- Andres Kask, Tartu</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-225">
              <div className="flex items-center mb-4" data-id="element-226">
                <div className="flex text-yellow-400" data-id="element-227">
                  {[...Array(5)].map((_, i) => <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-228">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-229" />
                    </svg>)}
                </div>
              </div>
              <p className="text-gray-600 mb-4" data-id="element-230">
                "Used MoveEst for our office relocation and couldn't be happier.
                They handled everything professionally and were very
                accommodating."
              </p>
              <p className="font-medium" data-id="element-231">- Liis Mets, Pärnu</p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-blue-600 text-white py-16" data-id="element-232">
        <div className="container mx-auto px-4 text-center" data-id="element-233">
          <h2 className="text-3xl font-bold mb-6" data-id="element-234">Ready to Make Your Move?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-235">
            Book your stress-free moving experience today and let our
            professionals handle everything.
          </p>
          <Link to="/order" data-id="element-236">
            <Button variant="secondary" size="lg" data-id="element-237">
              Book Your Move Now
            </Button>
          </Link>
        </div>
      </section>
    </div>;
};